import axios from '../axiosClient';
import { logError } from 'utils/logs';
export const getReservations = async () => {
    var _a;
    try {
        const { data } = await axios.get('/payment/reservation');
        return data;
    }
    catch (e) {
        const error = e;
        // Check if error is AxiosError and the response status is 404
        if (error.isAxiosError && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 404)
            return [];
        logError(e);
        throw e;
    }
};
export const getTransactionsWaiting = async () => {
    var _a;
    try {
        const { data } = await axios.get('/payment/transaction_waiting');
        return data.map((transaction) => {
            let paymentMethodTypes;
            const stripe_metadata = transaction.stripe_metadata || {};
            try {
                paymentMethodTypes = JSON.parse(transaction.payment_method_types.replaceAll("'", '"'))[0];
            }
            catch (e) {
                logError(e);
                paymentMethodTypes = transaction.payment_method_types;
            }
            return {
                created: transaction.created,
                updated: transaction.updated,
                date_money_received: null,
                kyc_status: null,
                id_transaction: transaction.id_stripe,
                payment_method: paymentMethodTypes,
                signed: transaction.signed,
                from_company: (stripe_metadata === null || stripe_metadata === void 0 ? void 0 : stripe_metadata.from_company) === "True" || ((stripe_metadata === null || stripe_metadata === void 0 ? void 0 : stripe_metadata.from_company) !== "False" && (stripe_metadata === null || stripe_metadata === void 0 ? void 0 : stripe_metadata.from_company)) || false,
                company: null,
                person: null,
                id_project: transaction.id_project,
                email: transaction.email,
                iss: transaction.iss,
                id_stripe: transaction.id_stripe,
                status: transaction.status,
                amount: transaction.amount,
                transaction: transaction,
            };
        });
    }
    catch (err) {
        const error = err;
        // Check if error is AxiosError and the response status is 404
        if (error.isAxiosError && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 404)
            return [];
        logError(err);
        throw err;
    }
};
export const getProjects = async () => {
    var _a;
    try {
        const { data } = await axios.get('/payment/list_project_investment');
        return data;
    }
    catch (e) {
        const error = e;
        // Check if error is AxiosError and the response status is 404
        if (error.isAxiosError && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 404)
            return [];
        logError(e);
        throw e;
    }
};
export const getLoiByTransactionId = async (id) => {
    var _a, _b;
    try {
        return await axios.get(`/payment/file/LOI?id_transaction=${id}`);
    }
    catch (err) {
        const error = err;
        if (error.isAxiosError && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 400 || ((_b = error.response) === null || _b === void 0 ? void 0 : _b.status) === 404)
            return undefined;
        logError(err);
        throw err;
    }
};
